import { render, staticRenderFns } from "./QuickCreateWebsites.vue?vue&type=template&id=b4715188&scoped=true&"
import script from "./QuickCreateWebsites.vue?vue&type=script&lang=ts&"
export * from "./QuickCreateWebsites.vue?vue&type=script&lang=ts&"
import style0 from "./QuickCreateWebsites.vue?vue&type=style&index=0&id=b4715188&prod&lang=scss&scoped=true&"
import style1 from "./QuickCreateWebsites.vue?vue&type=style&index=1&id=b4715188&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4715188",
  null
  
)

export default component.exports